import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { createMuiTheme, MuiThemeProvider } from "@material-ui/core/styles";
import { makeStyles } from "@material-ui/core/styles";
import { Link } from "react-router-dom";
import Navigator from "../Navigator/Navigator.js";
import Avatar from "@material-ui/core/Avatar";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import TextField from "@material-ui/core/TextField";
import Paper from "@material-ui/core/Paper";
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import Typography from "@material-ui/core/Typography";
import API, { set } from "../../actions";
import Copyright from "./Copyright";
import styles from "./styles";
import queryString from "query-string";
const useStyles = makeStyles(theme => styles);

const Reepay = props => {
    const _queryString = queryString.parse(props.location.search);
    console.log("_queryString",_queryString);
    const [notLoaded, setNotLoaded] = useState(null);
    useEffect(() => {
        (async () => {               
            if(_queryString.reepayURL){
                let r = await API.registerInvoice(_queryString.customerHandle);
                setNotLoaded(true);
                console.log(r);              
            } 
           
        })();
    }, [_queryString]);

    if(notLoaded === true){
        console.log('notLoaded');
        window.location = _queryString.reepayURL;
    }
    return  <></>;
};

export default Reepay;
